import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';
import { getCoreDataSecurityActionPlanSlice } from './get';

export const coreDataSecurityActionPlanReducers = combineReducers({
	get: getCoreDataSecurityActionPlanSlice.asyncReducers
});

export const coreDataSecurityActionPlanWatchers = combineAllWatchers([
	getCoreDataSecurityActionPlanSlice.asyncWatchers
]);
